import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystemSiteService {

  constructor(
    private http: HttpClient
  ) { }


  get_faq(): Observable<any> {
    let url = `${environment.site_URL}/frequently_asked_questions`;
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_social(): Observable<any> {
    let url = `${environment.site_URL}/social`;
    return this.http.get<any[]>(url, environment.security.options);
  }


    get_lab_partner(): Observable<any> {
    let url = `${environment.site_URL}/lab_partner`;
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_practitioner_type(): Observable<any> {
    let url = `${environment.site_URL}/practitioner_type`;
    return this.http.get<any[]>(url, environment.security.options);
  }


  get_branch(): Observable<any> {
    let url = `${environment.site_URL}/branch`;
    return this.http.get<any[]>(url, environment.security.options);
  }



  get_testimonial(_id?: string): Observable<any> {
    let url = `${environment.site_URL}/testimonial/${_id ? encodeURIComponent(_id) : ""}`
    console.log(url);
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_system_status(): Observable<any> {
    let url = `${environment.site_URL}/system_status`;
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_system_notifications(): Observable<any> {
    let url = `${environment.site_URL}/notifications`;
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_system_status_global(): Observable<any> {
    let url = `${environment.site_URL}/system_status_global`;
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_practice(practice_number?: string): Observable<any> {
    let url = `${environment.site_URL}/search_practice_number/${practice_number}`;
    console.log(url);
    return this.http.post<any[]>(url, environment.security.options);
  }

  get_downloads(group?: string): Observable<any> {
    let url = `${environment.site_URL}/downloads/${group ? encodeURIComponent(group) : ""}`;
    console.log(url);
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_news(_id?: string): Observable<any> {
    let url = `${environment.site_URL}/news/${_id ? encodeURIComponent(_id) : ""}`
    console.log(url);
    return this.http.get<any[]>(url, environment.security.options);
  }

  get_download_file(_id): Observable<any> {
    let url = `${environment.site_URL}/download_file/${_id}`;
    console.log(url);
    return this.http.get(url, { responseType: 'blob' });
  }


  reset_password_request_otp(user_data: any): Observable<any> {
    let url = `${environment.site_URL}/reset_password_request_otp`;
    console.log(url);
    return this.http.post<any[]>(url, user_data, environment.security.options);
  }

  reset_password(user_data: any): Observable<any> {
    let url = `${environment.site_URL}/reset_password`;
    console.log(url);
    return this.http.post<any[]>(url, user_data, environment.security.options);
  }

  contact_form_email(email_data: any): Observable<any> {
    let url = `${environment.site_URL}/contact_form_email`;
    console.log(url);
    return this.http.post<any[]>(url, email_data, environment.security.options);
  }

    contact_form_get_a_quote(email_data: any): Observable<any> {
    let url = `${environment.site_URL}/contact_form_get_a_quote`;
    console.log(url);
    return this.http.post<any[]>(url, email_data, environment.security.options);
  }

  referral_form_email(email_data: any): Observable<any> {
    let url = `${environment.site_URL}/referral_form_email`;
    console.log(url);
    return this.http.post<any[]>(url, email_data, environment.security.options);
  }



}
